import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/components/ui/select';
import { Z_INDEX_DROPDOWN_IN_MODAL } from '@/components/ui/zIndex';
import { TreatmentRecordRequestChannelType } from '@/services/api/generated/treatmentRecordRequestsService';

interface RequestMethodSelectorProps {
  value?: TreatmentRecordRequestChannelType;
  onChange: (type: TreatmentRecordRequestChannelType) => void;
  className?: string;
  /** Use when rendered inside a modal to ensure dropdown appears above it */
  inModal?: boolean;
}

const METHOD_LABELS: Record<TreatmentRecordRequestChannelType, string> = {
  portal: 'Portal',
  email: 'Email',
  fax: 'Fax',
  mail: 'Mail',
  human: 'Manual',
  phone: 'Phone',
};

const METHOD_OPTIONS: TreatmentRecordRequestChannelType[] = [
  'portal',
  'email',
  'fax',
  'mail',
];

export const RequestMethodSelector = ({
  value,
  onChange,
  className,
  inModal = false,
}: RequestMethodSelectorProps) => {
  return (
    <Select
      value={value}
      onValueChange={(newValue) =>
        onChange(newValue as TreatmentRecordRequestChannelType)
      }
    >
      <SelectTrigger className={className}>
        <SelectValue placeholder="Select method" />
      </SelectTrigger>
      <SelectContent
        style={inModal ? { zIndex: Z_INDEX_DROPDOWN_IN_MODAL } : undefined}
      >
        {METHOD_OPTIONS.map((method) => (
          <SelectItem key={method} value={method}>
            {METHOD_LABELS[method]}
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
};
